// Used in an iframe to message the extension from a YuJa origin
// Needs to be externally_connectable

const THEME_ORIGIN = document.location.ancestorOrigins?.[0] || document.referrer.replace(/\/$/, "") || "";

let instituteId: number | undefined;

window.addEventListener("message", async (ev) => {
	if (ev.origin !== THEME_ORIGIN) {
		return;
	}
	let message = ev.data;
	if (message?.require === "exists") {
		if (chrome?.runtime?.sendMessage) {
			chrome.runtime.sendMessage(import.meta.env.VITE_EXTENSION_ID, { request: "yuja-version" }, (res) => {
				if (chrome?.runtime?.lastError || !res) {
					window.parent.postMessage(
						{
							require: message.require,
							result: false,
						},
						THEME_ORIGIN,
					);
				} else {
					window.parent.postMessage(
						{
							require: message.require,
							result: true,
							version: res.version,
						},
						THEME_ORIGIN,
					);
				}
			});
		} else {
			window.parent.postMessage(
				{
					require: message.require,
					result: false,
				},
				THEME_ORIGIN,
			);
		}
	} else if (message?.type === "getInstituteId") {
		ev.source?.postMessage(
			{
				type: "sendInstituteId",
				instituteId,
			},
			{ targetOrigin: THEME_ORIGIN },
		);
	} else if (message?.type === "saveInstituteId" && typeof message.instituteId === "number") {
		instituteId = message.instituteId;
	} else if (message?.type === "saveAssessmentUrl" && typeof message.url === "string") {
		localStorage.setItem("currentAssessmentUrl", message.url);
		localStorage.setItem(
			"initialPortalState",
			JSON.stringify({
				currPage: "extensionSetup",
				returnToAssessmentInfo: { url: message.url, assessmentInfo: message.assessmentInfo },
			}),
		);
	} else if (message?.type === "saveMobileAssessmentUrl" && typeof message.url === "string") {
		localStorage.setItem("currentAssessmentUrl", message.url);
		localStorage.setItem(
			"initialPortalState",
			JSON.stringify({
				currPage: "mobileWorkflow",
				returnToAssessmentInfo: { url: message.url, assessmentInfo: message.assessmentInfo },
			}),
		);
	} else if (message?.type === "saveReportData" && typeof message.assessmentId === "string") {
		localStorage.setItem(
			"initialPortalState",
			JSON.stringify({
				currPage: "assessmentReport",
				reportContext: { lmsProvidedAssessmentId: message.assessmentId },
			}),
		);
	} else {
		const { requestId }: { requestId: string } = message;
		message = message.payload;
		const reply = (data: any) => {
			ev.source?.postMessage({ responseId: requestId, payload: data }, { targetOrigin: THEME_ORIGIN });
		};

		if (message?.type === "getLTIRef" && typeof message.instituteId === "number") {
			const ltiRef = await fetch(
				new URL(`/api/verity/ltiRef/${message.instituteId}`, import.meta.env.VITE_VERITY_ORIGIN),
			);
			const data = await ltiRef.text();
			reply(data);
		} else if (
			message?.type === "copyCheck" &&
			typeof message.instituteId === "number" &&
			typeof message.assessmentId === "string" &&
			typeof message.courseId === "string"
		) {
			const url = new URL(
				`/api/verity/lms-course/${message.courseId}/lms-assessment/${message.assessmentId}/copy-check?instituteId=${message.instituteId}`,
				import.meta.env.VITE_VERITY_ORIGIN,
			);
			if (message.type && typeof message.type === "string") {
				url.searchParams.append("type", message.type);
			}
			const res = await fetch(url, { method: "PUT" });
			if (res.ok) {
				reply(true);
			} else {
				reply(false);
			}
		} else if (
			message?.type === "isAssessmentVerityEnabled" &&
			typeof message.instituteId === "number" &&
			typeof message.assessmentId === "string" &&
			typeof message.courseId === "string"
		) {
			const url = new URL(
				`/api/verity/lms-course/${message.courseId}/lms-assessment/${message.assessmentId}/proctored?instituteId=${message.instituteId}`,
				import.meta.env.VITE_VERITY_ORIGIN,
			);
			const res = await fetch(url);
			if (res.ok) {
				const isVerityEnabled = await res.text();
				reply(isVerityEnabled === "true");
			} else {
				reply(false);
			}
		} else if (
			message?.type === "getProctoringOptions" &&
			typeof message.instituteId === "number" &&
			typeof message.assessmentId === "string" &&
			typeof message.courseId === "string"
		) {
			const url = new URL(
				`/api/verity/lms-course/${message.courseId}/lms-assessment/${message.assessmentId}/proctored/proctoringOption?instituteId=${message.instituteId}`,
				import.meta.env.VITE_VERITY_ORIGIN,
			);
			const res = await fetch(url);
			if (res.ok) {
				const proctoringOptions = await res.json();
				reply(proctoringOptions);
			} else {
				reply(undefined);
			}
		} else if (message?.type === "isVersionSupported" && typeof message.version === "string") {
			const url = new URL(`/api/verity/platform-info/version/${message.version}`, import.meta.env.VITE_VERITY_ORIGIN);
			const res = await fetch(url);
			if (res.ok) {
				const data = await res.json();
				const isSupported = data.versionSupported;
				reply(isSupported);
			} else {
				reply(false);
			}
		} else if (message?.type === "getPlatformInfo") {
			const url = new URL("/api/verity/platform-info", import.meta.env.VITE_VERITY_ORIGIN);
			const res = await fetch(url);
			if (res.ok) {
				reply(await res.json());
			} else {
				reply(undefined);
			}
		}
	}
});
